import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { SupplierPicker } from "./SupplierPicker";
import { supplierStatement } from "../../api/purchases";

// كشف حساب المورّد: فواتير دائنة، مدفوعات مدينة، ورصيد متحرك.
export const SupplierStatement = ({ supplierId: fixedId }) => {
  const { t } = useTranslation();
  const [supplierId, setSupplierId] = useState(fixedId || "");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!supplierId) return setData(null);
    supplierStatement(supplierId).then(setData).catch(() => setData(null));
  }, [supplierId]);

  return (
    <NeuCard className="grid gap-3 p-4" data-testid="supplier-statement">
      <p className="label-xs">{t("purchases.statement.title")}</p>
      {fixedId ? null : (
        <SupplierPicker testid="statement-supplier" value={supplierId} onChange={setSupplierId} />
      )}

      {!data ? null : (
        <div className="grid gap-2">
          <p className="text-xs font-bold">
            {t("purchases.statement.closing")}:{" "}
            <span className="num font-mono text-primary">{data.closing_balance}</span>
            {data.supplier?.credit_limit && Number(data.supplier.credit_limit) > 0 ? (
              <span className="ms-2 text-[11px] text-muted-foreground">
                {t("purchases.statement.creditLimit")}: <span className="num">{data.supplier.credit_limit}</span>
              </span>
            ) : null}
          </p>
          <div className="overflow-auto">
            <table className="w-full min-w-[32rem] text-xs">
              <thead>
                <tr className="text-[11px] text-muted-foreground">
                  {["date", "kind", "number", "credit", "debit", "balance"].map((key) => (
                    <th key={key} className="p-2">{t(`purchases.statement.${key}`)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.entries.map((row, index) => (
                  <tr key={index} className="border-t border-border/40"
                      data-testid={`statement-row-${index}`}>
                    <td className="num p-2 text-center font-mono">{row.date}</td>
                    <td className="p-2 text-center font-bold">{t(`purchases.statement.${row.kind}`)}</td>
                    <td className="num p-2 text-center font-mono">{row.number || "—"}</td>
                    <td className="num p-2 text-center font-mono text-destructive">{row.credit}</td>
                    <td className="num p-2 text-center font-mono text-primary">{row.debit}</td>
                    <td className="num p-2 text-center font-mono font-bold">{row.balance}</td>
                  </tr>
                ))}
                {!data.entries.length ? (
                  <tr>
                    <td colSpan={6} className="p-3 text-center text-muted-foreground"
                        data-testid="statement-empty">
                      {t("purchases.statement.empty")}
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </NeuCard>
  );
};
